import {action} from 'mobx';

import apiCompanySignGetAllStore from './apiCompanySignGetAllStore';
import ApiBaseStore from '../common/apiBaseStore';
import {STATE_PENDING, STATE_FULFILLED} from '../../../constants/asyncConstants';
import {EXPIRE_TIME, EXPIRES_IN, EXPIRES_PENDING} from '../../../constants/storeConstants';
import serverApi from '../../../utils/serverApi';

/**
 * Creates a new sign.
 */
class ApiSignCreateStore extends ApiBaseStore {
  /**
   * Creates a new sign using the api.
   *
   * @param {{}} newSignData
   */
  @action makeRequest(newSignData) {
    this.state = STATE_PENDING;
    this.data = null;
    this.error = null;
    this[EXPIRE_TIME] = Date.now() + EXPIRES_PENDING;

    serverApi.signCreate(newSignData).then(
      action('signCreateSuccess', (newSignId) => {
        this.state = STATE_FULFILLED;
        this.data = newSignId;
        this.error = null;
        this[EXPIRE_TIME] = Date.now() + EXPIRES_IN;

        apiCompanySignGetAllStore.refresh(true);
      })
    ).catch(
      action('signCreateError', (signCreateError) => {
        this.state = STATE_FULFILLED;
        this.data = null;
        this.error = signCreateError;
      })
    );
  }
}

export default new ApiSignCreateStore();
